import { transformDateValue } from 'core/js/FormUtils';
export const getCategory2productView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let category2productList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Category Id","fieldValue":transformDataValue(data.categoryid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Product Id","fieldValue":transformDataValue(data.productid,"ID"), "fieldType":"ID"},
              
              
            ],
            'dataList': [
                
              ]
          }

          category2productList.push(card);
  })
  return category2productList;
}